import { render } from "./GocardlessGuarantee.vue?vue&type=template&id=016f1a72"
import script from "./GocardlessGuarantee.vue?vue&type=script&lang=js"
export * from "./GocardlessGuarantee.vue?vue&type=script&lang=js"

import "./GocardlessGuarantee.vue?vue&type=style&index=0&id=016f1a72&lang=css"

import exportComponent from "/runner/_work/cb-checkout/cb-checkout/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__